import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { EmailCampaignManager } from "@/features/admin/components/email-campaign-manager";
import { PageContainer } from "@fleet/ui";

function AdminEmailCampaignsPage() {
  return (
    <PageContainer maxWidth="6xl">
      <EmailCampaignManager />
    </PageContainer>
  );
}

/** New-campaign form addressable by URL (#15b G8). */
interface AdminEmailCampaignsSearch {
  new?: boolean;
}

export const adminEmailCampaignsRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email/campaigns",
  validateSearch: (raw: Record<string, unknown>): AdminEmailCampaignsSearch => ({
    new: raw.new === true || raw.new === "1" || raw.new === "true" ? true : undefined,
  }),
  component: AdminEmailCampaignsPage,
});
